import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=9a33d9ee&scoped=true&"
import script from "./Documents.vue?vue&type=script&lang=js&"
export * from "./Documents.vue?vue&type=script&lang=js&"
import style0 from "./Documents.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Documents.vue?vue&type=style&index=1&id=9a33d9ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a33d9ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DocumentUpload: require('/codebuild/output/src2428694706/src/cc-portal/components/DocumentUpload.vue').default,BankStatementUpload: require('/codebuild/output/src2428694706/src/cc-portal/components/BankStatementUpload.vue').default,DocumentDialog: require('/codebuild/output/src2428694706/src/cc-portal/components/DocumentDialog.vue').default})
